// @ts-nocheck

import { applyMiddleware, createStore, Store } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga'
import { persistStore, persistReducer, createTransform } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import rootReducer, { ReduxState } from './rootReducer'

import rootSaga from './rootSaga'

const sagaMiddleware = createSagaMiddleware()

/** Never rehydrate UI-blocking auth loading flag */
const userPersistTransform = createTransform(
  (inboundState) => {
    if (!inboundState || typeof inboundState !== 'object') {
      return inboundState
    }
    const { loading: _loading, ...rest } = inboundState
    return rest
  },
  (outboundState) => {
    if (!outboundState || typeof outboundState !== 'object') {
      return outboundState
    }
    return { ...outboundState, loading: false }
  },
  { whitelist: ['UserReducer'] }
)

const persistConfig = {
  key: 'applaus-customer',
  whitelist: ['UserReducer', 'EventReducer', 'CheckoutReducer'],
  transforms: [userPersistTransform],
  storage
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const enhancer: any = applyMiddleware(sagaMiddleware)

const store: Store<ReduxState> = createStore(
  persistedReducer,
  composeWithDevTools(enhancer)
)

export const persistor = persistStore(store)

sagaMiddleware.run(rootSaga)

export default store
